import axios from '@core/axios/axios.js'
import { ref } from 'vue'
import { useToast } from 'vue-toastification'
import { handleAxiosError } from '../axios/handleError'
import { camelToSnake } from '../utils/helpers'

const DEFAULT_OPTIONS = {
  method: 'GET',
  showErrorToast: true,
  params: {},
}

const delay = (ms) => new Promise((resolve) => setTimeout(() => resolve(), ms))

export const useHttp = (options) => {
  let opts = {
    ...DEFAULT_OPTIONS,
    ...options,
  }

  let data = ref(null)
  let error = ref(null)
  let isLoading = ref(false)
  let isReady = ref(false)

  const toast = useToast()

  const onError = (err) => {
    const handledError = err.error ? handleAxiosError(err.error) : err?.message

    error.value = handledError
    opts.showErrorToast && toast.error(handledError)

    isReady.value = false
    isLoading.value = false

    throw err
  }
  const onSuccess = (response) => {
    data.value = response.data

    isLoading.value = false
    isReady.value = true
  }

  const execute = async (
    { params = {}, url = null, payload = {} },
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    try {
      isLoading.value = true

      // await delay(1000)

      const response = await axios({
        method: opts.method,
        params: camelToSnake(params ?? {}),
        url,
        data: payload,
        onUploadProgress: opts.onUploadProgress,
      })

      onSuccess(response)
      successCallback(data.value)
    } catch (error) {
      errorCallback(error)
      onError(error)
    }
  }

  return { data, isLoading, isReady, execute, error }
}
